import React, { useState, useEffect, Fragment, useContext, useMemo } from 'react';
import {
	Row,
	Col,
	Button,
	// Tab,
	// Tabs,
	Form,
	Card,
	ButtonToolbar,
	InputGroup,
	FormControl,
	Spinner,
	OverlayTrigger,
	Tooltip,
	// Nav,
} from 'react-bootstrap';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import {
	getProject,
	editProjectExpenseItems,
	getProjectCompanyTenders,
	getProjectTenders,
	editProjectTenders,
	editProject,
} from '@lib/api';
import StatusBar from '@components/StatusBar';
import { InputNumber } from 'primereact';
import CustomizedCheckbox from '@components/materialComponents/Checkbox';
import { Lens, TooltipInfoIcon } from '@icons';
import { OETrans } from 'components/translation/OETrans';
import { translate } from 'components/translation/translation';
import BudgetStreams from 'components/planning/BudgetStreams';
import BudgetWp from 'components/planning/BudgetWp';
import { UserContext } from 'components/contexts/UserProvider';
import NavTabs from '@components/atomic/molecules/NavTabs/NavTabs';

const Planning = ({ project, isExternalAdmin }) => {
	const { isOe, userAccess, isPartnerUser, isCoordinator } = useContext(UserContext);
	const [thisProject, setThisProject] = useState({});
	const [optionsCompanyTenders, setOptionsCompanyTenders] = useState([]);
	const [sbShow, setSbShow] = useState(<></>);
	const [projectNoticeExpenseItems, setProjectNoticeExpenseItems] = useState([]);
	const [projectExpenseItems, setProjectExpenseItems] = useState([]);
	const [left, setLeft] = useState([]);
	const [right, setRight] = useState([]);
	const [checked, setChecked] = useState([]);
	const [originLeft, setOriginLeft] = useState([]);
	const [originRight, setOriginRight] = useState([]);
	const [indirectCosts, setIndirectCosts] = useState(false);
	const [indirectCostsPerc, setIndirectCostsPerc] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	// const [activeKey, setActiveKey] = useState('');
	const isProjectWp = useMemo(() => project?.streamConfigurationType === 'WP', [project?.streamConfigurationType]);
	const isProjectSco = useMemo(() => project?.sco, [project?.sco]);
	const [isSetupModified, setIsSetupModified] = useState(false);
	const [isAssociationModified, setIsAssociationModified] = useState(false);
	const hasPartnerAccess = useMemo(() => (isProjectWp ? isPartnerUser : isCoordinator), [isPartnerUser, isCoordinator, isProjectWp]);

	const handleStatusBar = (status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	};

	useEffect(() => {
		if (project) {
			setThisProject(project);
			setIndirectCosts(
				project?.streamConfigurationType === 'WP' ? project?.sco || project.indirectCostsPerc : project.indirectCostsPerc > 0,
			);
			setIndirectCostsPerc(project.indirectCostsPerc);
		}
	}, [project]);

	// useEffect(() => {
	// 	if (project.id) {
	// 		setActiveKey(isCoordinator || isOe || isExternalAdmin ? 'economics' : 'target');
	// 	}
	// }, [isCoordinator, isOe, isExternalAdmin, project.id]);

	useEffect(() => {
		if (thisProject.id) {
			setIsLoading(true);

			getProjectCompanyTenders(thisProject.companyId, true).then((companyTenders) => {
				if (companyTenders.success) {
					setOptionsCompanyTenders(
						companyTenders.data.map((companyTender) => ({
							value: companyTender.id,
							label: companyTender.tenderNumber,
						})),
					);
				}
			});

			setProjectExpenseItems(thisProject.expenseItems);

			setProjectNoticeExpenseItems(thisProject.noticeExpenseItems);
		}
	}, [thisProject]);

	useEffect(() => {
		if (thisProject.id) {
			getProjectTenders(thisProject.id)
				.then((associatedTenders) => {
					setIsLoading(true);

					if (associatedTenders.success) {
						let tempSelectedTenders = optionsCompanyTenders
							.filter((optionCompanyTender) => {
								return associatedTenders.data.some((associatedTender) => {
									return Number(optionCompanyTender.value) === Number(associatedTender.id);
								});
							})
							.map((filteredOpt) => ({
								...filteredOpt,
								unlinkable: associatedTenders.data
									.filter((assTender) => assTender.id === filteredOpt.value)
									.map((el) => el.unlinkable)
									.pop(),
							}));

						let tempLeft = optionsCompanyTenders
							.filter((opt) => {
								return !tempSelectedTenders.some((f) => {
									return f.value === opt.value;
								});
							})
							.map((filteredOpt) => ({
								...filteredOpt,
								unlinkable: true,
							}));

						setLeft(tempLeft);
						setOriginLeft(tempLeft);

						setRight(tempSelectedTenders);
						setOriginRight(tempSelectedTenders);
					}
				})
				.then(() => {
					setIsLoading(false);
				});
		}
	}, [optionsCompanyTenders, thisProject.id]);

	const selectTender = async () => {
		setSbShow(<></>);
		//console.log('e:', e);

		const arrTenderIds = right.map((el) => el.value);
		//console.log('arrTenderIds', arrTenderIds);

		const data = {
			tenderIds: arrTenderIds,
			//_method: 'PUT',
		};

		const result = await editProjectTenders(thisProject.id, data);

		if (result.success) {
			handleStatusBar('success', `Gare associate con successo`, true);

			setRight(
				optionsCompanyTenders
					.filter((optionCompanyTender) => {
						return result.data.some((associatedTender) => {
							return Number(optionCompanyTender.value) === Number(associatedTender.id);
						});
					})
					.map((filteredOpt) => ({
						...filteredOpt,
						unlinkable: result.data
							.filter((assTender) => assTender.id === filteredOpt.value)
							.map((el) => el.unlinkable)
							.pop(),
					})),
			);
		} else {
			handleStatusBar('error', `Non è stato possibile associare la gara alla voce di spesa`, false);
		}
	};

	const handleSave = async () => {
		setIsLoading(true);
		setSbShow(<></>);

		if (indirectCosts && indirectCostsPerc <= 0) {
			handleStatusBar('error', 'Il valore della percentuale addizionale deve essere maggiore dello 0%', true);
			setIsLoading(false);
			return;
		}

		if (projectExpenseItems.some((el) => el.generalExpenses && el.geShare === 0)) {
			handleStatusBar(
				'error',
				'Se la voce "Gestione spese generali" è abilitata, il valore della percentuale associata deve essere maggiore dello 0%',
				true,
			);
			setIsLoading(false);
			return;
		}

		let resultOfActions = [true];
		let resultOfMessages = [];

		let [projectExpenseItemsResult] = await Promise.all([
			handleItemList('projectExpenseItems', projectExpenseItems, editProjectExpenseItems),
		]);

		const resultOfAll = resultOfActions.concat(projectExpenseItemsResult ? projectExpenseItemsResult.resultOfActionsTemp : []);
		const resultOfAllMessages = resultOfMessages.concat(projectExpenseItemsResult ? projectExpenseItemsResult.messageResult : []);
		//console.log('resultOfAll', resultOfAll);
		//console.log('resultOfAllMessages', resultOfAllMessages);

		if (resultOfAll.length === 0 || (resultOfAll.length > 0 && resultOfAll.every((el) => el === true))) {
			// Save Project
			const projectResult = await editProject(thisProject.id, {
				indirect_costs_perc: indirectCostsPerc,
			});
			if (projectResult.success) {
				handleStatusBar('success', translate('common.message.edited', 'Elemento modificato con successo'), true);
			} else {
				handleStatusBar(
					'error',
					translate('common.error.save', 'Si è verificato un errore durante il salvataggio delle informazioni'),
					false,
				);
			}
			setIsLoading(false);
		} else {
			handleStatusBar(
				'error',
				resultOfAllMessages.length > 0
					? Object.values(resultOfAllMessages[0].data).join() || resultOfAllMessages[0].message
					: translate('common.error.save', 'Si è verificato un errore durante il salvataggio delle informazioni'),
				false,
			);
			setIsLoading(false);
		}

		setTimeout(() => {
			getProject(thisProject.id).then((retrievedProject) => {
				setThisProject(retrievedProject.data);
				setProjectExpenseItems(retrievedProject.data.expenseItems);
				setProjectNoticeExpenseItems(retrievedProject.data.noticeExpenseItems);
			});
		}, 500);
	};

	const handleItemList = async (entityType, itemList, editAPI) => {
		let resultOfActionsTemp = [];

		let validationFields = [];

		switch (entityType) {
			case 'projectExpenseItems':
				validationFields = ['name'];
				break;
			default:
				validationFields = [];
		}

		let result;
		let messageResult = [];

		await Promise.all(
			itemList.map(async (item) => {
				const resultOfEvery = validationFields.every(
					(field) => item[field] || (Array.isArray(item[field]) && item[field].every((el) => el)),
				);
				//console.log('item', item);

				if (resultOfEvery) {
					if (item.id) {
						const { name, createdAt, createdBy, updatedAt, updatedBy, ...restItem } = item;
						result = await editAPI(thisProject.id, restItem);
						//console.log('result edit:', result);
						if (result.success === false) messageResult = result;
						resultOfActionsTemp.push(result.success);
					}
				} else {
					messageResult = {
						success: false,
						data: {
							validation: [`${entityType} ${translate('common.error.notsaved', 'non salvati')}`],
						},
					};
					resultOfActionsTemp.push(false);
					return;
				}
			}),
		);

		//console.log('messageResult', messageResult);
		return { resultOfActionsTemp, messageResult };
	};

	const handleSubRowChange = (fieldName, parentId, parentIndex, subId, event) => {
		if (!isSetupModified) setIsSetupModified(true);
		let updatedExpenses = [...projectExpenseItems];
		let tempUpdatedExpenses = updatedExpenses.filter((el) => el.projectNoticeExpenseItemId === parentId);

		const subIndex = tempUpdatedExpenses.findIndex((el) => el.id === subId);

		switch (fieldName) {
			case 'humanResource':
			case 'generalExpenses':
				const isChecked = event.target.checked === true ? 1 : 0;
				tempUpdatedExpenses[subIndex][fieldName] = isChecked;

				//comportamento input radio like tra humanResource e generalExpenses
				if (isProjectWp && isChecked)
					tempUpdatedExpenses[subIndex][fieldName === 'humanResource' ? 'generalExpenses' : 'humanResource'] = 0;

				if (fieldName === 'generalExpenses' && !isChecked) {
					tempUpdatedExpenses[subIndex]['geShare'] = 0;
				}
				break;
			case 'geShare':
				tempUpdatedExpenses[subIndex]['geShare'] = event.value;
				break;
			default:
				break;
		}

		updatedExpenses = updatedExpenses.filter((el) => el.projectNoticeExpenseItemId !== parentId);
		updatedExpenses.push(tempUpdatedExpenses);

		setProjectExpenseItems(updatedExpenses.flat());
	};

	const handleIndirectCostsToggle = () => {
		setIndirectCosts(!indirectCosts);

		if (indirectCosts) {
			setIndirectCostsPerc(0);
		}

		//Proj Stream: If additionalcost if set to true disable and set check to false all general expenses
		if (!isProjectWp && !indirectCosts) {
			const updatedItems = projectExpenseItems.map((item) => ({
				...item,
				generalExpenses: false,
			}));

			setProjectExpenseItems(updatedItems);
		}
	};

	const ExpenseTab = () => {
		const scoTooltip = (
			<OverlayTrigger
				placement="top"
				delay={{ show: 200, hide: 400 }}
				overlay={
					<Tooltip>
						{translate(
							'common.tooltip.scowarning',
							'Non sono state abilitate le opzioni di costo semplificate. I costi indiretti per i costi interni non saranno applicati',
						)}
					</Tooltip>
				}
			>
				<TooltipInfoIcon className="tooltip-ico" style={{ width: '1rem' }} />
			</OverlayTrigger>
		);

		return (
			<Form>
				<div id="planning-table">
					<Row className="mt-2 mb-4">
						<h5>Voci di spesa</h5>
					</Row>
				</div>
				<div>
					<>
						<Row className="mb-4">
							<Col className="fw-bold">Costi Indiretti {isProjectWp ? '(Costi Interni)' : ''}</Col>
						</Row>
						<Row className="mb-4">
							<Col className="ps-4 align-middle col-9">
								<Form.Check
									type="checkbox"
									name="indirectCosts"
									checked={indirectCosts}
									label={<>Abilita{isProjectWp && !isProjectSco ? scoTooltip : ''}</>}
									onChange={(e) => {
										if (!isSetupModified) setIsSetupModified(true);
										handleIndirectCostsToggle(e);
									}}
								/>
							</Col>

							<Col className="align-middle col-3">
								<InputNumber
									name="indirectCostsPerc"
									min={0}
									max={300}
									step={1}
									minFractionDigits={0}
									maxFractionDigits={0}
									disabled={!indirectCosts}
									mode="decimal"
									className={
										Number(indirectCostsPerc) > 100 || (indirectCosts && Number(indirectCostsPerc) === 0)
											? 'md input-candidacy justify-content-center p-invalid'
											: 'md input-candidacy justify-content-center'
									}
									suffix={' %'}
									onChange={(e) => {
										if (!isSetupModified) setIsSetupModified(true);
										setIndirectCostsPerc(e.value);
									}}
									value={indirectCostsPerc}
								/>
							</Col>
						</Row>
					</>
					{projectNoticeExpenseItems
						?.sort((a, b) => a.position - b.position)
						.map((expense, index) => (
							<React.Fragment key={'expItem' + index}>
								<Row className="mb-4">
									<Col className="fw-bold">{expense.name}</Col>
								</Row>
								{projectExpenseItems
									.filter((el) => el.projectNoticeExpenseItemId === expense.id)
									.sort((a, b) => a.position - b.position)
									.map((subRow, subIndex) => {
										return (
											<Row key={'tr' + subIndex} className="mb-4">
												<Col key={`${subIndex}-${subRow.projectNoticeExpenseItemId}`} className="ps-4 align-middle">
													<span>{subRow.name ?? ''}</span>
												</Col>
												<Col className="ps-4 align-middle">
													<Form.Check
														type="checkbox"
														name="humanResource"
														checked={subRow.humanResource}
														label="Abilita gestione costi interni"
														onChange={(e) => handleSubRowChange('humanResource', expense.id, index, subRow.id, e)}
													/>
												</Col>
												<Col className="align-middle">
													<Form.Check
														type="checkbox"
														name="generalExpenses"
														checked={subRow.generalExpenses}
														disabled={isProjectWp ? false : indirectCosts}
														label={isProjectWp ? 'Abilita gestione Costi Indiretti (Costi esterni)' : 'Abilita gestione spese generali'}
														onChange={(e) => handleSubRowChange('generalExpenses', expense.id, index, subRow.id, e)}
													/>
												</Col>
												<Col className="align-middle">
													<InputNumber
														name="geShare"
														min={0}
														max={300}
														step={1}
														minFractionDigits={0}
														maxFractionDigits={0}
														disabled={!subRow.generalExpenses}
														mode="decimal"
														className={
															Number(subRow.geShare) > 100 || (Number(subRow.generalExpenses) && Number(subRow.geShare) === 0)
																? 'md input-candidacy justify-content-center p-invalid'
																: 'md input-candidacy justify-content-center'
														}
														suffix={' %'}
														value={subRow.geShare}
														onChange={(e) => handleSubRowChange('geShare', expense.id, index, subRow.id, e)}
													/>
												</Col>
											</Row>
										);
									})}
							</React.Fragment>
						))}
				</div>

				<Row className="mt-5 text-center">
					<Col>
						<Button disabled={isLoading || !isSetupModified} onClick={handleSave}>
							<OETrans code="common.save" fallback={'Salva'} />
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	const SelectTendersTab = () => {
		const not = (a, b) => {
			return a.filter((value) => b.indexOf(value) === -1);
		};

		const intersection = (a, b) => {
			return a.filter((value) => b.indexOf(value) !== -1);
		};

		const union = (a, b) => {
			return [...a, ...not(b, a)];
		};

		const leftChecked = intersection(checked, left);
		const rightChecked = intersection(checked, right);

		const handleToggle = (value) => () => {
			const currentIndex = checked.indexOf(value);
			const newChecked = [...checked];

			if (currentIndex === -1) {
				newChecked.push(value);
			} else {
				newChecked.splice(currentIndex, 1);
			}

			setChecked(newChecked);
		};

		const numberOfChecked = (items) => intersection(checked, items).length;

		const handleToggleAll = (items) => () => {
			if (numberOfChecked(items) === items.length) {
				setChecked(not(checked, items));
			} else {
				setChecked(union(checked, items));
			}
		};

		const handleCheckedRight = () => {
			let tempRight = right.concat(leftChecked);
			let tempLeft = not(left, leftChecked);

			setRight(tempRight);
			setOriginRight(tempRight);
			setLeft(tempLeft);
			setOriginLeft(tempLeft);
			setChecked(not(checked, leftChecked));
		};

		const handleCheckedLeft = () => {
			let tempLeft = left.concat(rightChecked);
			let tempRight = not(right, rightChecked);

			setLeft(tempLeft);
			setOriginLeft(tempLeft);
			setRight(tempRight);
			setOriginRight(tempRight);
			setChecked(not(checked, rightChecked));
		};

		const onFilterTextBoxChanged = (e, setList, originList) => {
			let value = e.target.value.toLowerCase();

			if (value && value.trim().length > 0) {
				let tempListFiltered = originList.filter((el) => el.label.toLowerCase().includes(value));

				setList(tempListFiltered);
			} else {
				setList(originList);
			}
		};

		const customList = (title, items, listType) => {
			let itemsAvailable = items.filter((el) => el.unlinkable);
			//console.log('itemsAvailable', itemsAvailable);

			return (
				<Card className="px-2 py-1">
					<Card.Header>
						<ListItem className="px-0 py-1" role="listitem">
							<ListItemIcon onClick={handleToggleAll(itemsAvailable)}>
								<CustomizedCheckbox
									checked={numberOfChecked(itemsAvailable) === itemsAvailable.length && itemsAvailable.length !== 0}
									/* indeterminate={
                                       numberOfChecked(itemsAvailable) !== itemsAvailable.length && numberOfChecked(itemsAvailable) !== 0
                                    } */
									disabled={itemsAvailable.length === 0}
								/>
							</ListItemIcon>
							<ListItemText id={title} primary={title} secondary={`${numberOfChecked(items)}/${items.length} selezionati`} />
							<ButtonToolbar className="justify-content-end">
								<InputGroup className="search-table align-items-center mt-3 mt-md-0 ms-2">
									<FormControl
										type="text"
										className="filter-text-box"
										placeholder={translate('common.search', 'Cerca') + '...'}
										onInput={(e) =>
											onFilterTextBoxChanged(e, listType === 'left' ? setLeft : setRight, listType === 'left' ? originLeft : originRight)
										}
									/>
									<Lens />
								</InputGroup>
							</ButtonToolbar>
						</ListItem>
					</Card.Header>

					<Card.Body>
						<List
							sx={{
								//width: 200,
								//height: 230,
								bgcolor: 'background.paper',
								overflow: 'auto',
								height: 560,
							}}
							dense
							component="div"
							role="list"
						>
							{items.map((item) => {
								const labelId = `transfer-list-all-item-${item}-label`;
								return (
									<ListItem key={item.value} role="listitem" button onClick={handleToggle(item)} disabled={item.unlinkable === false}>
										<ListItemIcon>
											<CustomizedCheckbox
												checked={checked.indexOf(item) !== -1}
												tabIndex={-1}
												disableRipple
												disabled={item.unlinkable === false}
											/>
										</ListItemIcon>
										<ListItemText id={labelId} primary={`${item.label}`} />
									</ListItem>
								);
							})}
						</List>
					</Card.Body>
				</Card>
			);
		};

		return (
			<div className="mt-0">
				<Row className="mb-4">
					<h5 className="mt-2 mb-2">Associa</h5>
					<br />
					<Link to="/tenders" target="_blank" rel="noreferrer" className="link-tender small">
						oppure carica nuova gara
					</Link>
				</Row>

				{/* <Row>
               <Select
                  id={`id-select`}
                  placeholder={translate('common.placeholder.select', 'Seleziona...')}
                  options={optionsCompanyTenders}
                  value={right}
                  onChange={(e) => selectTender(e)}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  styles={{
                     container: (base) => ({
                        ...base,
                        width: "fit-content",
                        minWidth: "17rem",
                     }),
                  }}
               />
            </Row> */}

				<Row className="justify-content-center align-items-center">
					<Col>{customList('Associabili', left, 'left')}</Col>

					<Col className="col-1">
						<Row className="align-items-center flex-column">
							{isLoading && (
								<div className="text-center my-4">
									<Spinner animation="border" role="status" size="sm" />
								</div>
							)}
						</Row>
						<Row className="align-items-center flex-column">
							<Button
								className="my-3 transfer-button px-3"
								variant={leftChecked.length === 0 ? 'outline-info' : 'primary'}
								onClick={(e) => {
									if (!isAssociationModified) setIsAssociationModified(true);
									handleCheckedRight(e);
								}}
								disabled={leftChecked.length === 0}
							>
								&gt;
							</Button>
							<Button
								className="my-3 transfer-button px-3"
								variant={rightChecked.length === 0 ? 'outline-info' : 'primary'}
								onClick={(e) => {
									if (!isAssociationModified) setIsAssociationModified(true);
									handleCheckedLeft(e);
								}}
								disabled={rightChecked.length === 0}
							>
								&lt;
							</Button>
						</Row>
					</Col>

					<Col>{customList('Gare associate', right, 'right')}</Col>
				</Row>

				<Row className="mt-4 text-center">
					<Col>
						<Button onClick={selectTender} disabled={!isAssociationModified}>
							<OETrans code="common.save" fallback={'Salva'} />
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	const tabNavItems = [
		{
			eventKey: 'economics',
			title: 'Setup',
			transCode: 'common.candidacy.setup',
			shouldBeVisible: isOe || hasPartnerAccess || isExternalAdmin,
			content: <ExpenseTab />,
		},
		{
			eventKey: 'target',
			title: 'Budget',
			transCode: 'common.candidacy.budget',
			content:
				thisProject?.streamConfigurationType === 'STREAM' ? (
					<BudgetStreams
						thisProject={thisProject}
						projectNoticeExpenseItems={projectNoticeExpenseItems}
						isEnabledToView={isOe || isExternalAdmin}
						projectExpenseItems={projectExpenseItems}
					/>
				) : thisProject?.streamConfigurationType === 'WP' ? (
					<BudgetWp
						thisProject={thisProject}
						projectNoticeExpenseItems={projectNoticeExpenseItems}
						isEnabledToView={isOe}
						projectExpenseItems={projectExpenseItems}
						isThereApplicationEconomFramework={thisProject.applicationEconomicFrameworkValues.length ? true : false}
					/>
				) : null,
		},
		{
			eventKey: 'cashflow',
			title: 'Incasso',
			transCode: 'common.candidacy.cashflow',
			content:
				thisProject?.streamConfigurationType === 'STREAM' ? (
					<BudgetStreams
						thisProject={thisProject}
						projectNoticeExpenseItems={projectNoticeExpenseItems}
						isEnabledToView={isOe || isExternalAdmin}
						projectExpenseItems={projectExpenseItems}
						isCashflow
					/>
				) : thisProject?.streamConfigurationType === 'WP' ? (
					<BudgetWp
						thisProject={thisProject}
						projectNoticeExpenseItems={projectNoticeExpenseItems}
						isEnabledToView={isOe}
						projectExpenseItems={projectExpenseItems}
						isThereApplicationEconomFramework={thisProject.applicationEconomicFrameworkValues.length ? true : false}
						isCashflow
					/>
				) : null,
		},
		{
			eventKey: 'tenders',
			title: 'Associazione gare',
			transCode: 'common.candidacy.tenders',
			shouldBeVisible:
				!(
					thisProject?.streamConfigurationType === 'STREAM' &&
					thisProject?.advancedConfig.some((el) => el.name === 'disable_tenders' && el.enabled)
				) &&
				(isOe || isExternalAdmin) &&
				userAccess.isAbovePartner,
			content: <SelectTendersTab />,
		},
	];

	return (
		<>
			<NavTabs tabNavItems={tabNavItems} />

			{sbShow}
		</>
	);
};
export default Planning;
